import { render } from "./ContextMenuSperator.vue?vue&type=template&id=c306a596&ts=true"
import script from "./ContextMenuSperator.vue?vue&type=script&lang=ts"
export * from "./ContextMenuSperator.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Code\\GitHub\\vue3-context-menu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__